/**
 * Report generator identity for county letterheads (PDF/CSV).
 * Shows name + payroll/employee number and marks system-generated reports.
 */

function pickFromObject(obj, keys) {
  if (!obj || typeof obj !== "object") return "";
  for (const k of keys) {
    const v = obj[k];
    if (v != null && String(v).trim() !== "") return String(v).trim();
  }
  return "";
}

export function resolveReportGeneratorMeta() {
  let user = {};
  let employee = {};
  let rbac = {};
  try {
    user = JSON.parse(sessionStorage.getItem("userInfo") || "{}") || {};
  } catch (_) {
    user = {};
  }
  try {
    employee = JSON.parse(sessionStorage.getItem("employeeInfo") || sessionStorage.getItem("employee") || "{}") || {};
  } catch (_) {
    employee = {};
  }
  try {
    rbac = JSON.parse(sessionStorage.getItem("rbac_context") || "{}") || {};
  } catch (_) {
    rbac = {};
  }

  const name =
    pickFromObject(user, ["names", "fullName", "name", "username"]) ||
    pickFromObject(employee, ["fullName", "names", "firstName"]) ||
    pickFromObject(rbac, ["username"]) ||
    sessionStorage.getItem("sessionNames") ||
    "System User";

  const first = pickFromObject(employee, ["firstName"]);
  const last = pickFromObject(employee, ["lastName"]);
  const fullFromParts = [first, last].filter(Boolean).join(" ").trim();
  const displayName = fullFromParts || name;

  const payrollNo =
    pickFromObject(employee, ["empNo", "payrollNo", "payrollNumber", "personalNumber"]) ||
    pickFromObject(user, ["empNo", "idNo", "nationalId"]) ||
    pickFromObject(rbac, ["employee_id"]) ||
    sessionStorage.getItem("sessionIdNo") ||
    "";

  const byLine = payrollNo
    ? `Generated by: ${displayName} (Payroll / Employee No: ${payrollNo})`
    : `Generated by: ${displayName}`;

  return {
    name: displayName,
    payrollNo,
    byLine,
    systemLine: "System generated report",
    generatedAt: new Date().toLocaleString("en-KE"),
  };
}

/** Lines for CSV letterhead footers/headers (no commas escaped). */
export function reportGeneratorCsvLines(meta = null) {
  const m = meta || resolveReportGeneratorMeta();
  return [
    `Generated: ${m.generatedAt}`,
    m.byLine,
    m.systemLine,
  ];
}
